import React, { useState, useEffect } from 'react';
import './StudentDashboard.css';
import blogImage1 from '../as.avif'; // Substitua pelo caminho da sua imagem de blog
import blogImage2 from '../as.avif'; // Substitua pelo caminho da sua imagem de blog

const StudentDashboard = () => {
  const [activeTab, setActiveTab] = useState('Progresso');
  const [selectedSubjectForQuizzes, setSelectedSubjectForQuizzes] = useState(null);
  const [selectedSubjectForLessons, setSelectedSubjectForLessons] = useState(null);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [fontSize, setFontSize] = useState(16);
  const [isBionic, setIsBionic] = useState(false);
  const [isReading, setIsReading] = useState(false);
  const [voiceSpeed, setVoiceSpeed] = useState(1);
  const [voiceGender, setVoiceGender] = useState('female');
  const [voiceLang, setVoiceLang] = useState('en-US');
  const [voices, setVoices] = useState([]);
  const [testSearch, setTestSearch] = useState('');
  const [bookSearch, setBookSearch] = useState('');
  const [userData, setUserData] = useState({
    name: 'Txoboy Prodi',
    email: 'txoboy@example.com',
    password: '',
  });
  const [successMessage, setSuccessMessage] = useState('');

  // Dados de exemplo
  const subjects = [
    { name: 'Biologia', id: 'biology' },
    { name: 'Matemática', id: 'math' },
    { name: 'Física', id: 'physics' },
  ];

  const lessons = {
    biology: [
      {
        section: 'Introdução à Biologia',
        items: [
          { title: 'Lição 1: O que é Vida?', duration: '30 mins' },
          { title: 'Lição 2: Células e suas Funções', duration: '30 mins' },
          { title: 'Lição 3: Introdução à Genética', duration: '30 mins' },
        ],
      },
    ],
    math: [
      {
        section: 'Introdução à Matemática',
        items: [
          { title: 'Lição 1: Números e Operações', duration: '30 mins' },
          { title: 'Lição 2: Frações e Decimais', duration: '30 mins' },
          { title: 'Lição 3: Introdução à Álgebra', duration: '30 mins' },
        ],
      },
    ],
    physics: [
      {
        section: 'Introdução à Física',
        items: [
          { title: 'Lição 1: O que é Física?', duration: '30 mins' },
          { title: 'Lição 2: Leis de Newton', duration: '30 mins' },
          { title: 'Lição 3: Energia e Trabalho', duration: '30 mins' },
        ],
      },
    ],
  };

  const quizzes = {
    'biology-quiz1': {
      title: 'Quiz 1: O que é Vida?',
      questions: Array.from({ length: 10 }, (_, i) => ({
        question: `Pergunta ${i + 1}: O que caracteriza um ser vivo?`,
        options: ['Respiração', 'Movimento', 'Crescimento', 'Todas as anteriores'],
        correctAnswer: 'Todas as anteriores',
      })),
    },
    'biology-quiz2': {
      title: 'Quiz 2: Células',
      questions: Array.from({ length: 10 }, (_, i) => ({
        question: `Pergunta ${i + 1}: Qual é a função do núcleo celular?`,
        options: ['Armazenar água', 'Controlar atividades celulares', 'Produzir energia', 'Transportar nutrientes'],
        correctAnswer: 'Controlar atividades celulares',
      })),
    },
    'math-quiz1': {
      title: 'Quiz 1: Números',
      questions: Array.from({ length: 10 }, (_, i) => ({
        question: `Pergunta ${i + 1}: Qual é o resultado de ${i + 1} + ${i + 2}?`,
        options: [`${i + 3}`, `${i + 4}`, `${i + 5}`, `${i + 6}`],
        correctAnswer: `${i + 3}`,
      })),
    },
    'math-quiz2': {
      title: 'Quiz 2: Operações',
      questions: Array.from({ length: 10 }, (_, i) => ({
        question: `Pergunta ${i + 1}: Qual é o resultado de ${i + 1} * ${i + 2}?`,
        options: [`${(i + 1) * (i + 2)}`, `${(i + 1) * (i + 3)}`, `${(i + 2) * (i + 3)}`, `${(i + 1) * (i + 4)}`],
        correctAnswer: `${(i + 1) * (i + 2)}`,
      })),
    },
    'physics-quiz1': {
      title: 'Quiz 1: Física Básica',
      questions: Array.from({ length: 10 }, (_, i) => ({
        question: `Pergunta ${i + 1}: O que é inércia?`,
        options: ['Tendência de um corpo em repouso permanecer em repouso', 'Força gravitacional', 'Energia cinética', 'Acelerção'],
        correctAnswer: 'Tendência de um corpo em repouso permanecer em repouso',
      })),
    },
    'physics-quiz2': {
      title: 'Quiz 2: Leis de Newton',
      questions: Array.from({ length: 10 }, (_, i) => ({
        question: `Pergunta ${i + 1}: Qual é a primeira lei de Newton?`,
        options: ['Ação e reação', 'Inércia', 'Força = massa * aceleração', 'Energia potencial'],
        correctAnswer: 'Inércia',
      })),
    },
  };

  const progressData = {
    totalLessons: 30,
    completedLessons: 15,
    subjects: [
      { name: 'Biologia', progress: 50 },
      { name: 'Matemática', progress: 70 },
      { name: 'Física', progress: 30 },
    ],
  };

  const descriptions = {
    biology: 'A Biologia é o estudo da vida e dos organismos vivos, abrangendo desde a estrutura celular até os ecossistemas complexos.',
    math: 'A Matemática é a ciência dos números, formas e padrões, fundamental para resolver problemas e entender o mundo.',
    physics: 'A Física estuda as leis da natureza, desde o movimento dos corpos até as forças que governam o universo.',
  };

  const tests = [
    { name: 'Teste de Biologia - Introdução à Vida', file: 'teste-biologia-vida.pdf' },
    { name: 'Teste de Biologia - Células', file: 'teste-biologia-celulas.pdf' },
    { name: 'Teste de Matemática - Números', file: 'teste-matematica-numeros.pdf' },
    { name: 'Teste de Matemática - Álgebra Básica', file: 'teste-matematica-algebra.pdf' },
    { name: 'Teste de Física - Leis de Newton', file: 'teste-fisica-newton.pdf' },
  ];

  const books = [
    { name: 'Livro de Biologia - Fundamentos da Vida', file: 'livro-biologia-vida.pdf' },
    { name: 'Livro de Biologia - Genética Básica', file: 'livro-biologia-genetica.pdf' },
    { name: 'Livro de Matemática - Introdução à Álgebra', file: 'livro-matematica-algebra.pdf' },
    { name: 'Livro de Matemática - Geometria Básica', file: 'livro-matematica-geometria.pdf' },
    { name: 'Livro de Física - Mecânica Clássica', file: 'livro-fisica-mecanica.pdf' },
  ];

  const textContent = (subjectId) => descriptions[subjectId] || 'Descrição não disponível.';

  // Carrega as vozes disponíveis no navegador
  useEffect(() => {
    const loadVoices = () => {
      const availableVoices = window.speechSynthesis.getVoices();
      setVoices(availableVoices);
    };

    loadVoices();
    window.speechSynthesis.onvoiceschanged = loadVoices;

    return () => {
      window.speechSynthesis.onvoiceschanged = null;
    };
  }, []);

  // Funções para controle de leitura
  const increaseFontSize = () => {
    setFontSize((prevSize) => Math.min(prevSize + 2, 32));
  };

  const decreaseFontSize = () => {
    setFontSize((prevSize) => Math.max(prevSize - 2, 12));
  };

  const toggleBionicReading = () => {
    setIsBionic(!isBionic);
  };

  const toggleVoiceReading = (subjectId) => {
    if (isReading) {
      window.speechSynthesis.cancel();
      setIsReading(false);
    } else {
      const utterance = new SpeechSynthesisUtterance(textContent(subjectId));
      utterance.lang = voiceLang;
      utterance.rate = voiceSpeed;

      const selectedVoice = voices.find((voice) => {
        const isLangMatch = voice.lang === voiceLang;
        const isGenderMatch =
          voice.name.toLowerCase().includes(voiceGender) ||
          (voiceGender === 'female' && voice.name.toLowerCase().includes('female')) ||
          (voiceGender === 'male' && voice.name.toLowerCase().includes('male'));
        return isLangMatch && (isGenderMatch || true);
      });

      if (selectedVoice) {
        utterance.voice = selectedVoice;
      }

      window.speechSynthesis.speak(utterance);
      setIsReading(true);

      utterance.onend = () => {
        setIsReading(false);
      };
    }
  };

  const applyBionicReading = (text) => {
    if (!isBionic) return text;

    return text.split(' ').map((word, index) => {
      const midPoint = Math.ceil(word.length / 2);
      const firstHalf = word.slice(0, midPoint);
      const secondHalf = word.slice(midPoint);
      return (
        <span key={index}>
          <b>{firstHalf}</b>{secondHalf}{' '}
        </span>
      );
    });
  };

  const handleQuizClick = (quizId) => {
    setSelectedQuiz(quizId);
  };

  const handleBackToQuizzes = () => {
    setSelectedQuiz(null);
  };

  const handleLogout = () => {
    alert('Sessão terminada! Você será redirecionado para a página de login.');
    // Aqui você pode adicionar lógica para redirecionar para a página de login
    // Exemplo: window.location.href = '/login';
  };

  const handleUserDataChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleUserDataSubmit = (e) => {
    e.preventDefault();
    if (!userData.name || !userData.email) {
      alert('Por favor, preencha todos os campos obrigatórios (Nome e E-mail).');
      return;
    }
    // Aqui você pode adicionar lógica para enviar os dados ao servidor
    setSuccessMessage('Dados atualizados com sucesso!');
    setTimeout(() => setSuccessMessage(''), 3000); // Limpa a mensagem após 3 segundos
  };

  const filteredTests = tests.filter((test) =>
    test.name.toLowerCase().includes(testSearch.toLowerCase())
  );

  const filteredBooks = books.filter((book) =>
    book.name.toLowerCase().includes(bookSearch.toLowerCase())
  );

  return (
    <div className="student-dashboard">
      {/* Barra Lateral */}
      <div className="sidebar">
        <h1 className="logo">eBB</h1>
        <ul className="menu">
          <li
            className={`menu-item ${activeTab === 'Progresso' ? 'active' : ''}`}
            onClick={() => setActiveTab('Progresso')}
          >
            Progresso
          </li>
          <li
            className={`menu-item ${activeTab === 'Quizzes' ? 'active' : ''}`}
            onClick={() => {
              setActiveTab('Quizzes');
              setSelectedSubjectForQuizzes(null);
              setSelectedQuiz(null);
            }}
          >
            Quizzes
          </li>
          <li
            className={`menu-item ${activeTab === 'Lessons' ? 'active' : ''}`}
            onClick={() => {
              setActiveTab('Lessons');
              setSelectedSubjectForLessons(null);
            }}
          >
            Aulas
          </li>
          <li
            className={`menu-item ${activeTab === 'Downloads' ? 'active' : ''}`}
            onClick={() => {
              setActiveTab('Downloads');
              setTestSearch('');
              setBookSearch('');
            }}
          >
            Baixar Ficheiros
          </li>
          <li
            className={`menu-item ${activeTab === 'Profile' ? 'active' : ''}`}
            onClick={() => setActiveTab('Profile')}
          >
            Perfil
          </li>
        </ul>
        {/* Seção de Usuário na Parte Inferior */}
        <div className="user-info">
          <span>Bem-vindo, {userData.name}</span>
          <button className="logout-btn" onClick={handleLogout}>
            Terminar Sessão
          </button>
        </div>
      </div>

      {/* Conteúdo Principal */}
      <div className="main-content">
        {activeTab === 'Progresso' && (
          <div className="progress-section">
            <h2>Progresso do Plano de Aulas</h2>
            <p>
              Você completou {progressData.completedLessons} de {progressData.totalLessons} lições.
            </p>
            <div className="progress-bar">
              <div
                className="progress"
                style={{ width: `${(progressData.completedLessons / progressData.totalLessons) * 100}%` }}
              ></div>
              <span>{(progressData.completedLessons / progressData.totalLessons) * 100}%</span>
            </div>
            <h3>Progresso por Disciplina</h3>
            {progressData.subjects.map((subject, index) => (
              <div key={index} className="subject-progress">
                <p>{subject.name}</p>
                <div className="progress-bar">
                  <div className="progress" style={{ width: `${subject.progress}%` }}></div>
                  <span>{subject.progress}%</span>
                </div>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'Quizzes' && (
          <div className="quizzes-section">
            {!selectedSubjectForQuizzes ? (
              <>
                <h2>Lista de Disciplinas</h2>
                <div className="subjects-list">
                  {subjects.map((subject) => (
                    <div
                      key={subject.id}
                      className="subject-card"
                      onClick={() => setSelectedSubjectForQuizzes(subject.id)}
                    >
                      <span className="subject-icon"></span>
                      <h3>{subject.name}</h3>
                    </div>
                  ))}
                </div>
              </>
            ) : selectedQuiz ? (
              <div className="quiz-section">
                <h2>{quizzes[selectedQuiz].title}</h2>
                {quizzes[selectedQuiz].questions.map((q, idx) => (
                  <div key={idx} className="quiz-question">
                    <h4>{q.question}</h4>
                    {q.options.map((option, optIdx) => (
                      <label key={optIdx} className="quiz-option">
                        <input type="radio" name={`question-${idx}`} value={option} />
                        {option}
                      </label>
                    ))}
                  </div>
                ))}
                <button className="submit-quiz-btn">Enviar Quiz</button>
                <button className="back-btn" onClick={handleBackToQuizzes}>
                  Voltar para Quizzes
                </button>
              </div>
            ) : (
              <div className="quizzes-list">
                <h2>Quizzes de {subjects.find((s) => s.id === selectedSubjectForQuizzes).name}</h2>
                <button
                  className="back-btn"
                  onClick={() => setSelectedSubjectForQuizzes(null)}
                >
                  Voltar para Disciplinas
                </button>
                {Object.keys(quizzes)
                  .filter((quizId) => quizId.startsWith(selectedSubjectForQuizzes))
                  .map((quizId, index) => (
                    <div key={index} className="quiz-item" onClick={() => handleQuizClick(quizId)}>
                      <span>{quizzes[quizId].title}</span>
                    </div>
                  ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'Lessons' && (
          <div className="lessons-section">
            {!selectedSubjectForLessons ? (
              <>
                <h2>Lista de Disciplinas</h2>
                <div className="subjects-list">
                  {subjects.map((subject) => (
                    <div
                      key={subject.id}
                      className="subject-card"
                      onClick={() => setSelectedSubjectForLessons(subject.id)}
                    >
                      <span className="subject-icon"></span>
                      <h3>{subject.name}</h3>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="read-page-container">
                {/* Barra Lateral com Lições */}
                <div className="sidebar-lessons">
                  <h2>{subjects.find((s) => s.id === selectedSubjectForLessons).name}</h2>
                  <button
                    className="back-btn"
                    onClick={() => setSelectedSubjectForLessons(null)}
                  >
                    Voltar para Disciplinas
                  </button>
                  {lessons[selectedSubjectForLessons].map((section, index) => (
                    <div key={index} className="section">
                      <h3>{section.section}</h3>
                      {section.items.map((item, idx) => (
                        <div key={idx} className="lesson-item">
                          <span>{item.title}</span>
                          {item.duration && <span className="duration">{item.duration}</span>}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>

                {/* Conteúdo Principal */}
                <div className="main-content-lessons">
                  {/* Controles de Leitura */}
                  <div className="controls">
                    <div className="font-size-controls">
                      <button onClick={increaseFontSize} className="control-btn">
                        Aumentar Tamanho da Fonte
                      </button>
                      <button onClick={decreaseFontSize} className="control-btn">
                        Diminuir Tamanho da Fonte
                      </button>
                    </div>
                    <button onClick={toggleBionicReading} className="control-btn">
                      {isBionic ? 'Desativar Leitura Biônica' : 'Ativar Leitura Biônica'}
                    </button>
                    <div className="voice-controls">
                      <button
                        onClick={() => toggleVoiceReading(selectedSubjectForLessons)}
                        className="control-btn"
                      >
                        {isReading ? 'Parar Leitura por Voz' : 'Iniciar Leitura por Voz'}
                      </button>
                      <div className="voice-options">
                        <select
                          value={voiceSpeed}
                          onChange={(e) => setVoiceSpeed(parseFloat(e.target.value))}
                        >
                          <option value={0.5}>Lento (0.5x)</option>
                          <option value={1}>Normal (1x)</option>
                          <option value={1.5}>Rápido (1.5x)</option>
                        </select>
                        <select
                          value={voiceGender}
                          onChange={(e) => setVoiceGender(e.target.value)}
                        >
                          <option value="female">Voz Feminina</option>
                          <option value="male">Voz Masculina</option>
                        </select>
                        <select
                          value={voiceLang}
                          onChange={(e) => setVoiceLang(e.target.value)}
                        >
                          <option value="en-US">Inglês (EUA)</option>
                          <option value="pt-BR">Português (Brasil)</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Conteúdo */}
                  <div className="content">
                    <h1>{subjects.find((s) => s.id === selectedSubjectForLessons).name}</h1>
                    <p style={{ fontSize: `${fontSize}px` }} className="main-text">
                      {applyBionicReading(textContent(selectedSubjectForLessons))}
                    </p>
                    <div className="tags">
                      <span className="tag">{subjects.find((s) => s.id === selectedSubjectForLessons).name.toLowerCase()}</span>
                      <span className="tag">aprendizado</span>
                      <span className="tag">educação</span>
                    </div>
                    <div className="author">
                      <span>Escrito por: eBB</span>
                      <button className="follow-btn">Seguir</button>
                    </div>
                  </div>

                  {/* Seção de Blogs Relacionados */}
                  <div className="related-blogs">
                    <h2>Conteúdo Relacionado</h2>
                    <div className="blog-posts">
                      <div className="blog-post">
                        <img src={blogImage1} alt="Blog 1" />
                        <h3>Introdução à {subjects.find((s) => s.id === selectedSubjectForLessons).name}</h3>
                        <p>Explore os conceitos básicos de {subjects.find((s) => s.id === selectedSubjectForLessons).name} com lições práticas.</p>
                        <a href="#" className="read-more">Leia Mais</a>
                        <span className="views">10,000</span>
                      </div>
                      <div className="blog-post">
                        <img src={blogImage2} alt="Blog 2" />
                        <h3>Avançando em {subjects.find((s) => s.id === selectedSubjectForLessons).name}</h3>
                        <p>Aprofunde seus conhecimentos em {subjects.find((s) => s.id === selectedSubjectForLessons).name} com exercícios avançados.</p>
                        <a href="#" className="read-more">Leia Mais</a>
                        <span className="views">8,500</span>
                      </div>
                    </div>
                    <div className="pagination">
                      <button className="pagination-btn">{'<'}</button>
                      <button className="pagination-btn">{'>'}</button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 'Downloads' && (
          <div className="downloads-section">
            <h2>Baixar Ficheiros</h2>

            {/* Seção de Testes */}
            <div className="download-category">
              <h3>Testes</h3>
              <input
                type="text"
                placeholder="Procurar testes por nome..."
                value={testSearch}
                onChange={(e) => setTestSearch(e.target.value)}
                className="search-input"
              />
              <div className="download-list">
                {filteredTests.length > 0 ? (
                  filteredTests.map((test, index) => (
                    <div key={index} className="download-item">
                      <span>{test.name}</span>
                      <a href={`/${test.file}`} download className="download-btn">
                        Baixar PDF
                      </a>
                    </div>
                  ))
                ) : (
                  <p>Nenhum teste encontrado.</p>
                )}
              </div>
            </div>

            {/* Seção de Livros */}
            <div className="download-category">
              <h3>Livros</h3>
              <input
                type="text"
                placeholder="Procurar livros por nome..."
                value={bookSearch}
                onChange={(e) => setBookSearch(e.target.value)}
                className="search-input"
              />
              <div className="download-list">
                {filteredBooks.length > 0 ? (
                  filteredBooks.map((book, index) => (
                    <div key={index} className="download-item">
                      <span>{book.name}</span>
                      <a href={`/${book.file}`} download className="download-btn">
                        Baixar PDF
                      </a>
                    </div>
                  ))
                ) : (
                  <p>Nenhum livro encontrado.</p>
                )}
              </div>
            </div>
          </div>
        )}

        {activeTab === 'Profile' && (
          <div className="profile-section">
            <h2>Editar Perfil</h2>
            {successMessage && <p className="success-message">{successMessage}</p>}
            <form onSubmit={handleUserDataSubmit} className="profile-form">
              <div className="form-group">
                <label htmlFor="name">Nome:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={userData.name}
                  onChange={handleUserDataChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">E-mail:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={userData.email}
                  onChange={handleUserDataChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Nova Senha (opcional):</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={userData.password}
                  onChange={handleUserDataChange}
                  placeholder="Deixe em branco para não alterar"
                />
              </div>
              <button type="submit" className="save-btn">
                Salvar Alterações
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudentDashboard;